export default __webpack_public_path__ + "static/media/WWG2.cef91b34.jpg";